import { inject, Injectable } from '@angular/core';
import { ApiGateway } from '@sb/shared/api';
import { Observable } from 'rxjs';

import { MinijobBulkPayoutRequest, MinijobPayoutResponse } from './minijob-payout.model';

@Injectable({ providedIn: 'root' })
export class MinijobPayoutApiService {
  #gateway = inject(ApiGateway);

  getPayouts(payoutPeriod: string) {
    return this.#gateway.get<MinijobPayoutResponse>('minijob/payout', { params: { payout_period: payoutPeriod } });
  }

  bulkPayout(payload: MinijobBulkPayoutRequest): Observable<void> {
    return this.#gateway.post('minijob/payout', payload);
  }
}
